//for usage with record[index]
//noUncheckedIndexedAccess is impractical
export function maybeUndefined(v) {
    return v;
}
export const union = 
// eslint-disable-next-line @typescript-eslint/no-unnecessary-type-parameters
() => (v) => v;
export const tuple = (...x) => x;
export function isNonNullish(t) {
    return t !== undefined && t !== null;
}
export function assertNotNullish(value, context) {
    if (value === undefined || value === null) {
        throw new Error(`assertNotNullish failed: ${String(value)}` +
            // eslint-disable-next-line @typescript-eslint/no-base-to-string
            (context !== undefined ? `; context: ${String(context)}` : ''));
    }
}
export function assertNotEmpty(value, context) {
    if (value === undefined || value === null || value === '') {
        throw new Error(`assertNotEmpty failed: ${String(value)}` +
            // eslint-disable-next-line @typescript-eslint/no-base-to-string
            (context !== undefined ? `; context: ${String(context)}` : ''));
    }
}
export function hasShallowValue(obj, key) {
    return obj[key] !== null && obj[key] !== undefined;
}
export function assertShallowValue(obj, key, errorFactory) {
    if (obj[key] === null || obj[key] === undefined) {
        throw errorFactory();
    }
}
export function assertNotNullish2(value, errorFactory) {
    if (value === undefined || value === null) {
        throw errorFactory();
    }
}
//# sourceMappingURL=typescript.js.map